export default function TheCorePhilosophy() {
  const stats = [{
    value: "100%",
    label: "Systematic Execution"
  }, {
    value: "0.0%",
    label: "Subjective Bias"
  }, {
    value: "24/7",
    label: "Risk Oversight"
  }];
  return <section data-section-id="116866" id="the-edge" className="dark bg-[#141A22] text-[#F4EFE6] py-[100px] px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-[1fr_1px_1fr] gap-16 lg:gap-24 items-center">
        {}
        <div className="border-[#B8922A] border-l-[3px] pl-8 md:pl-12 py-2">
          <blockquote className="text-[#F4EFE6] text-[28px] font-serif italic leading-relaxed tracking-wide">
            "Strategic edge stems from a rules-based architecture. We replace market intuition with systematic precision, ensuring every trade is data-driven and risk-defined."
          </blockquote>
          <span className="text-[#B8922A] font-sans text-[10px] uppercase tracking-[0.3em] mt-8 block">
            Macaroni Capital
          </span>
        </div>

        {}
        <div className="bg-[#B8922A]/20 hidden h-full w-px self-stretch lg:block" aria-hidden="true"></div>

        {}
        <div className="flex flex-col">
          {stats.map((stat, i) => <div key={i} data-index={i} className="border-[#B8922A]/30 flex flex-col border-b py-10 first:pt-0 last:border-b-0 last:pb-0">
              <span className="text-[#B8922A] font-sans text-[56px] leading-none font-medium">
                {stat.value}
              </span>
              <span className="text-[#F4EFE6]/45 mt-3 font-sans text-[10px] uppercase tracking-[0.2em]">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}